import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
// import { Role } from '@/data/roles'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.localStorage
});

export default new Vuex.Store({
	state: {
		CurrentUser: null
	},
	getters: {
		CurrentUser: state => {
			return state.CurrentUser;
		}
	},
	mutations: {
		setCurrentUser(state, value) {
			state.CurrentUser = value;
		}
	},
	actions: {

	},
	plugins: [vuexLocal.plugin]
})
